import ExifReader from 'exifreader'

const getOrientation = (file: File) => {
  const reader = new FileReader()

  return new Promise<number>((resolve) => {
    reader.onload = (ev) => {
      const target = ev.target as EventTarget & { result: ArrayBuffer }
      try {
        resolve(ExifReader.load(target.result).Orientation.value)
      } catch {
        resolve(0)
      }
    }

    reader.readAsArrayBuffer(file.slice(0, 128 * 1024))
  })
}

const resetOrientation = (srcImage: HTMLImageElement, srcOrientation: number) => {
  const canvas = document.createElement('canvas')
  const width = srcImage.width
  const height = srcImage.height
  const ctx = canvas.getContext('2d')

  if (!ctx) {
    throw new Error('Cannot get canvas context.')
  }

  if (4 < srcOrientation && srcOrientation < 9) {
    canvas.width = height
    canvas.height = width
  } else {
    canvas.width = width
    canvas.height = height
  }

  switch (srcOrientation) {
    case 2: ctx.transform(-1, 0, 0, 1, width, 0); break
    case 3: ctx.transform(-1, 0, 0, -1, width, height); break
    case 4: ctx.transform(1, 0, 0, -1, 0, height); break
    case 5: ctx.transform(0, 1, 1, 0, 0, 0); break
    case 6: ctx.transform(0, 1, -1, 0, height, 0); break
    case 7: ctx.transform(0, -1, -1, 0, height, width); break
    case 8: ctx.transform(0, -1, 1, 0, 0, width); break
    default: break
  }

  ctx.drawImage(srcImage, 0, 0)

  const image = new Image()
  image.src = canvas.toDataURL()

  return image
}

export const createImageElementFromFile = (file: File) => {
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const fileUrl = window.URL.createObjectURL(file)
    const image = new Image()
    image.src = fileUrl

    image.onload = async () => {
      window.URL.revokeObjectURL(fileUrl)
      const orientation = await getOrientation(file)
      resolve(resetOrientation(image, orientation))
    }

    image.onerror = (err) => {
      window.URL.revokeObjectURL(fileUrl)
      reject(err)
    }
  })
}

export const cropImage = (
  imageEl: HTMLImageElement,
  crop: ReactCrop.Crop,
  maxWidth: number,
  maxHeight: number = maxWidth,
) => {
  const cropX = crop.x ?? 0
  const cropY = crop.y ?? 0

  const cropWidth = crop.width ?? 0
  const cropHeight = crop.height ?? 0

  const scale = Math.min(maxWidth / cropWidth, maxHeight / cropHeight, 1)
  const destWidth = cropWidth * scale
  const destHeight = cropHeight * scale

  const canvas = document.createElement('canvas')
  canvas.width = destWidth
  canvas.height = destHeight

  return new Promise<Blob>((resolve, reject) => {
    const ctx = canvas.getContext('2d')

    if (!ctx) {
      reject(new Error('Cannot get canvas context.'))
      return
    }

    ctx.drawImage(imageEl, cropX, cropY, cropWidth, cropHeight, 0, 0, destWidth, destHeight)

    canvas.toBlob((blob) => {
      if (blob) {
        resolve(blob)
      } else {
        reject(new Error('Cannot convert canvas to blob.'))
      }

    }, 'image/jpeg', 0.95)
  })
}
try {
    // @ts-ignore
    createImageElementFromFile.displayName = "createImageElementFromFile";
    // @ts-ignore
    createImageElementFromFile.__docgenInfo = { "description": "", "displayName": "createImageElementFromFile", "props": { "lastModified": { "defaultValue": null, "description": "", "name": "lastModified", "required": true, "type": { "name": "number" } }, "name": { "defaultValue": null, "description": "", "name": "name", "required": true, "type": { "name": "string" } }, "size": { "defaultValue": null, "description": "", "name": "size", "required": true, "type": { "name": "number" } }, "type": { "defaultValue": null, "description": "", "name": "type", "required": true, "type": { "name": "string" } }, "arrayBuffer": { "defaultValue": null, "description": "", "name": "arrayBuffer", "required": true, "type": { "name": "() => Promise<ArrayBuffer>" } }, "slice": { "defaultValue": null, "description": "", "name": "slice", "required": true, "type": { "name": "(start?: number, end?: number, contentType?: string) => Blob" } }, "stream": { "defaultValue": null, "description": "", "name": "stream", "required": true, "type": { "name": "() => ReadableStream<any>" } }, "text": { "defaultValue": null, "description": "", "name": "text", "required": true, "type": { "name": "() => Promise<string>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/lib/images.ts#createImageElementFromFile"] = { docgenInfo: createImageElementFromFile.__docgenInfo, name: "createImageElementFromFile", path: "src/lib/images.ts#createImageElementFromFile" };
}
catch (__react_docgen_typescript_loader_error) { }